// src/pages/factors/index.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../core/api';
import './Factors.css';
import FactorsSkeleton from './FactorsSkeleton';
import PrintTypeModal from './PrintTypeModal';

const Factors = () => {
  const [factors, setFactors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');
  const [printFactor, setPrintFactor] = useState(null);
  /* ============== Fetch ============== */
  const fetchFactors = async () => {
    try {
      const res = await api.get('/factors');
      const list = res.data?.factors || res.data || [];
      setFactors(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error('خطا در دریافت فاکتورها:', err);
      showMessage('خطا در دریافت فاکتورها', 'danger');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFactors();
  }, []);

  /* ============== Toast auto-hide ============== */
  const showMessage = (text, type = 'success') => {
    setMessage(text);
    setMessageType(type);
  };

  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => setMessage(''), 3000);
    return () => clearTimeout(t);
  }, [message]);

  /* ============== Delete ============== */
  const handleDelete = async (id) => {
    if (!window.confirm('این فاکتور حذف شود؟')) return;

    setDeletingId(id);
    try {
      await api.post(`/factors/${id}/delete`);
      setFactors((prev) => prev.filter((f) => f.id !== id));
      showMessage('فاکتور حذف شد', 'success');
    } catch (err) {
      console.error('خطا در حذف فاکتور:', err);
      showMessage(
        err.response?.data?.error || 'خطا در حذف فاکتور',
        'danger'
      );
    } finally {
      setDeletingId(null);
    }
  };

  /* ============== Render ============== */
  if (loading) {
    return <FactorsSkeleton />;
  }

  return (
    <>
      {message && (
        <div
          className={
            messageType === 'danger' ? 'toast-danger' : 'toast-success'
          }
        >
          {message}
        </div>
      )}

      <div className="card">
        <div className="card-header-row">
          <h2>لیست فاکتورها</h2>
          <Link className="btn" to="/dashboard/factors/new">
            <i className="fa-solid fa-plus" />
            <span className="btn-label">فاکتور جدید</span>
          </Link>
        </div>

        {factors.length === 0 ? (
          <div className="empty">هنوز فاکتوری ثبت نشده است.</div>
        ) : (
          factors.map((f) => {
            const total =
              f.totals?.total ??
              f.total ??
              (f.items
                ? f.items.reduce(
                    (s, it) =>
                      s + (it.qty * it.price - it.discount + (it.tax || 0)),
                    0
                  )
                : 0);

            return (
              <div className="list-item" key={f.id}>
                <div>
                  <div>
                    <b>{f.serial}</b>{' '}
                    <span className="badge">{f.date}</span>
                  </div>
                  <div className="muted">
                    {f.buyer?.name || 'بدون نام خریدار'} —{' '}
                    {Number(total).toLocaleString('fa-IR')} ریال
                  </div>
                </div>
                <div className="row-actions">
                  <button
  type="button"
  className="btn secondary small"
  onClick={() => setPrintFactor(f)}
>
  <i className="fa-solid fa-print" /> چاپ
</button>
                  <Link
                    className="btn secondary small"
                    to={`/dashboard/factors/${f.id}/edit`}
                  >
                    <i className="fa-solid fa-pen" /> ویرایش
                  </Link>
                  <button
                    type="button"
                    className="btn danger small"
                    onClick={() => handleDelete(f.id)}
                    disabled={deletingId === f.id}
                  >
                    {deletingId !== f.id && (
                      <i className="fa-solid fa-trash" />
                    )}
                    <span className="btn-label">
                      {deletingId === f.id ? 'در حال حذف...' : 'حذف'}
                    </span>
                    {deletingId === f.id && (
                      <span className="btn-spinner">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 50 50"
                          style={{
                            animation: 'spin 0.8s linear infinite',
                          }}
                        >
                          <circle
                            cx="25"
                            cy="25"
                            r="20"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="5"
                            strokeLinecap="round"
                            strokeDasharray="90 150"
                          />
                        </svg>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>

      {printFactor && (
  <PrintTypeModal factor={printFactor} onClose={() => setPrintFactor(null)} />
)}
    </>
  );
};

export default Factors;
